import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { Navigate, useLocation } from "react-router-dom";
import { CLIENT_PORTAL_PATHS } from "./clientPortalConstants";
import { useClientPortal } from "./ClientPortalContext";
import { useDataStore } from "../dataStore";

export function safeClientPortalReturnPath(value) {
  const path = String(value || "");
  if (!path.startsWith("/") || path.startsWith("//")) {
    return CLIENT_PORTAL_PATHS.account;
  }
  try {
    const parsed = new URL(path, "https://portal.invalid");
    if (parsed.origin !== "https://portal.invalid") {
      return CLIENT_PORTAL_PATHS.account;
    }
    if (parsed.pathname === CLIENT_PORTAL_PATHS.login) {
      return CLIENT_PORTAL_PATHS.account;
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch (error) {
    return CLIENT_PORTAL_PATHS.account;
  }
}

export default function RequireClientPortal({ children }) {
  const location = useLocation();
  const { t } = useDataStore();
  const {
    enabled,
    isAuthenticated,
    isRestoring,
    sessionExpired,
  } = useClientPortal();

  if (!enabled) return <Navigate to="/" replace />;
  if (isRestoring) {
    return (
      <Box
        role="status"
        aria-label={t("portal.guard.restoring")}
        sx={{ minHeight: 240, display: "grid", placeItems: "center" }}
      >
        <CircularProgress />
      </Box>
    );
  }
  if (!isAuthenticated) {
    const from = safeClientPortalReturnPath(
      `${location.pathname}${location.search}${location.hash}`
    );
    return (
      <Navigate
        to={CLIENT_PORTAL_PATHS.login}
        replace
        state={{ from, sessionExpired }}
      />
    );
  }
  return children;
}
